import React, { createContext, useContext, useEffect, useState } from "react";
import { pricebookApi } from "../lib/api";

const PricebookContext = createContext({ items: [], loading: true });

export function PricebookProvider({ children }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    pricebookApi
      .list()
      .then((docs) => setItems(docs || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return <PricebookContext.Provider value={{ items, loading }}>{children}</PricebookContext.Provider>;
}

export function usePricebook() {
  return useContext(PricebookContext);
}
